import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import {
  ModuleRegistry,
  InfiniteRowModelModule,
} from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useState, useMemo, useCallback } from "react";
import CustomHeader from "../../CustomHeader";
import ActionCellBilling from "../Utility/ActionCellBilling";

ModuleRegistry.registerModules([InfiniteRowModelModule]);

function MedicalBillingTable({
  // keeping original props signature for drop-in compatibility
  getPatients,
  isFetching,
  isLoading,
  isSuccess,
  gridRef,
  selectedFilters,
  hasData,
  setHasData,
}) {
  const navigate = useNavigate();

  const getStableColor = (key) => {
    const bgColors = [
      "bg-danger bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-secondary bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-primary bg-opacity-50",
      "bg-info bg-opacity-50",
      "bg-warning bg-opacity-50",
      "bg-success bg-opacity-50",
      "bg-info bg-opacity-10",
      "bg-success bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-danger bg-opacity-50",
      "bg-secondary bg-opacity-50",
    ];
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
      hash = key.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % bgColors.length;
    return bgColors[index];
  };

  // 10 static demo rows (based on provided shape)
  const staticRows = useMemo(
    () => [
      {
        patientID: "OP1001",
        patientName: "Ramesh Kumar",
        age: 32,
        gender: "Male",
        phone: "9876543210",
        doctor: "Dr. Sharma",
        department: "Cardiology",
        medicines: "Atorvastatin, Aspirin",
        batchNo: 12345,
        ExpiryDate: "12/2025",
        billItems: 2,
        totalAmount: "₹531.00",
        paymentMethod: "Cash",
 
      },
      {
        patientID: "OP1002",
        patientName: "Anita Devi",
        age: 45,
        gender: "Female",
        phone: "9123456780",
        doctor: "Dr. Verma",
        department: "Orthopedics",
        medicines: "Calcium, Vitamin D",
        batchNo: 12345,
         ExpiryDate:" 12/2025",
        billItems: 3,
        totalAmount: "₹849.60",
        paymentMethod: "UPI",
      },
      {
        patientID: "OP1003",
        patientName: "Vikram Singh",
        age: 28,
        gender: "Male",
        phone: "9812345678",
        doctor: "Dr. Mehta",
        department: "General Medicine",
        medicines: "Paracetamol, Pantoprazole",
           batchNo: 12345,
      ExpiryDate:" 12/2025",
        billItems: 2,
        totalAmount: "₹412.50",
        paymentMethod: "Card",
      },
      {
        patientID: "OP1004",
        patientName: "Priya Patel",
        age: 36,
        gender: "Female",
        phone: "9001122233",
        doctor: "Dr. Iyer",
        department: "Dermatology",
        medicines: "Cetirizine, Topical Steroid",
           batchNo: 12345,
          ExpiryDate:" 12/2025",
        billItems: 3,
        totalAmount: "₹678.00",
        paymentMethod: "Cash",
      },
      {
        patientID: "OP1005",
        patientName: "Amit Joshi",
        age: 41,
        gender: "Male",
        phone: "9822001100",
        doctor: "Dr. Banerjee",
        department: "Endocrinology",
        medicines: "Metformin, Glimepiride",
         batchNo: 12345,
          ExpiryDate:" 12/2025",
        billItems: 2,
        totalAmount: "₹735.40",
        paymentMethod: "UPI",
      },
      {
        patientID: "OP1006",
        patientName: "Neha Gupta",
        age: 30,
        gender: "Female",
        phone: "9898989898",
        doctor: "Dr. Kapoor",
        department: "Gynecology",
        medicines: "Folic Acid, Iron",
         batchNo: 12345,
        ExpiryDate:" 12/2025",
        billItems: 2,
        totalAmount: "₹389.00",
        paymentMethod: "Card",
      },
      {
        patientID: "OP1007",
        patientName: "Suresh Raina",
        age: 50,
        gender: "Male",
        phone: "9933445566",
        doctor: "Dr. Rao",
        department: "Neurology",
        medicines: "Gabapentin",
         batchNo: 12345,
          ExpiryDate:" 12/2025",
        billItems: 1,
        totalAmount: "₹950.00",
        paymentMethod: "Cash",
      },
      {
        patientID: "OP1008",
        patientName: "Kavita Nair",
        age: 27,
        gender: "Female",
        phone: "9077665544",
        doctor: "Dr. Kulkarni",
        department: "ENT",
        medicines: "Amoxicillin",
        batchNo: 12345,
           ExpiryDate :" 12/2025",
        billItems: 1,
        totalAmount: "₹299.00",
        paymentMethod: "UPI",
      },
      {
        patientID: "OP1009",
        patientName: "Rahul Verma",
        age: 34,
        gender: "Male",
        phone: "9955002211",
        doctor: "Dr. Thomas",
        department: "Orthopedics",
        medicines: "Ibuprofen, Calcium",
         batchNo: 12345,
          ExpiryDate :" 12/2025",
        billItems: 2,
        totalAmount: "₹610.75",
        paymentMethod: "Card",
      },
      {
        patientID: "OP1010",
        patientName: "Sneha More",
        age: 29,
        gender: "Female",
        phone: "9011223344",
        doctor: "Dr. Desai",
        department: "Ophthalmology",
        medicines: "Lubricant Drops",
         batchNo: 12345,
           ExpiryDate :" 12/2025",
        billItems: 1,
        totalAmount: "₹199.00",
        paymentMethod: "UPI",
      },
    ],
    []
  );

  const onGridReady = useCallback((params) => {
    const dataSource = {
      rowCount: undefined,
      getRows: (getRowsParams) => {
        const { startRow, endRow } = getRowsParams;
        const rowsThisPage = staticRows.slice(startRow, endRow);
        const lastRow =
          endRow >= staticRows.length ? staticRows.length : -1;

        if (typeof setHasData === "function") {
          setHasData(staticRows.length > 0);
        }

        getRowsParams.successCallback(rowsThisPage, lastRow);
      },
    };

    params.api.setGridOption("datasource", dataSource);
  }, [setHasData, staticRows]);

  const [colDefs] = useState([
    {
      headerName: "Patient Name",
      field: "patientName",
      width: 170,
      minWidth: 170,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: function (params) {
        if (params.value !== undefined) {
          const name = params.value || "U";
          const initial = name.charAt(0).toUpperCase();
          const bgColor = getStableColor(name);
          return (
            <div className="d-flex align-items-center gap-2">
              <div
                className={`d-flex justify-content-center align-items-center rounded-circle text-white fw-bold ${bgColor}`}
                style={{ width: "2rem", height: "2rem", fontSize: "0.875rem" }}
              >
                {initial}
              </div>
              <span className="fw-bold text-secondary small">{name}</span>
            </div>
          );
        }
      },
    },
    {
      headerName: "Patient ID",
      field: "patientID",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Gender",
      field: "gender",
      minWidth: 120,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Age",
      field: "age",
      minWidth: 80,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Phone",
      field: "phone",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Doctor",
      field: "doctor",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Department",
      field: "department",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Medicines",
      field: "medicines",
      minWidth: 220,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Batch No",
      field: "batchNo",
      minWidth: 120,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Expiry Date",
      field: "ExpiryDate",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Bill Items",
      field: "billItems",
      minWidth: 120,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Total Amount",
      field: "totalAmount",
      minWidth: 140,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          return (
            <span className="text-secondary fw-medium small">{params.value}</span>
          );
        }
      },
    },
    {
      headerName: "Payment Method",
      field: "paymentMethod",
      minWidth: 150,
      suppressSizeToFit: true,
      sortable: true,
      filter: true,
      cellStyle: {
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        if (params.value !== undefined) {
          // reuse the same pill styling approach from Status without changing styles
          return (
            <div
              className={`inline-block text-white border text-center px-3 py-1 rounded-full text-sm font-medium min-w-[120px]`}
              style={{ fontSize: "12px", lineHeight: "1rem", backgroundColor: '#194787', borderColor: '#194787' }}
            >
              {params.value}
            </div>
          );
        }
      },
    },
    {
      headerName: "Action",
      field: "",
      minWidth: 150,
      suppressSizeToFit: true,
      resizable: false,
      cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      cellRenderer: (params) => {
        if (params.data !== undefined) {
          return <ActionCellBilling data={params.data} />;
        }
      },
    },
  ]);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [
      {
        colId: "No of Team Members",
        minWidth: 900,
      },
    ],
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
      sortable: true,
      enableRowGroup: true,
      sort: "asc",
      resizable: true,
      headerComponent: CustomHeader,
    };
  }, []);

    const tableStyle = `

  .btn-IdWmkZEQJd {
  border: none;
    background: none;
    color: #035ecf;
    width: 2.4rem;
    height: 2.4rem;
    display: flex
;
    align-items: center;
    justify-content: center;
    border-radius: .245rem;
    padding: .25rem .5rem;
  }


.ag-horizontal-right-spacer.ag-scroller-corner {
    display: none !important;
}

.ag-header-viewport {
  overflow-x: hidden !important;
  will-change: auto !important;
}

/* Soothing green strip for selected row */
.ag-theme-quartz .ag-row-selected::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

.ag-cell-value{
  border-left: unset !important;
  border-right: 1px solid #e5e5e5 !important;
}

.ag-column-first{
  border: unset !important;
}

.ag-theme-quartz .ag-row-selected::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #77c658; /* strip stays green */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  z-index: 1;
}

/* Override hover background for selected rows */
.ag-theme-quartz .ag-row-hover .ag-row-selected:hover {
  background-color: #f4fbf1 !important; /* same as selected */
}

.ag-checkbox-input-wrapper::before{
  display: none;
}

.ag-checkbox-input-wrapper::after{
  display: none;
}

  .ag-ltr .ag-sort-indicator-icon {
    padding-left: var(--ag-grid-size);
    display: none;
}

  .ag-header, .ag-advanced-filter-header {
    // background-color: #ff525a;
      background-color: #203342;
    border-bottom: var(--ag-borders-critical) var(--ag-border-color);
}

            .ag-full-width-container{
            height : 100% !important;
          }


         

  
        .ag-header-cell-text {
        font-size: 0.9rem;
      text-transform: uppercase;
      color: #1e374f;
      font-weight: 600;
      font-family: 'Nunito', sans-serif !important;

        }

              .ag-header-cell-resize::after{
                      background-color: #1991eb52;
                  }


            .ag-theme-quartz{
            padding: 0.4rem;
            }

              .ag-ltr .ag-cell{

                      text-align: center;
                      display: flex;
                      // justify-content: center;
                      align-items: center;
              }

              .ag-header{
                  // background-color: #edeff6;
                   border: none;
                  padding: 0.5rem 0;

                  min-height: 44px !important;
              }

              .ag-row {
               border: 1px solid #eeedf0;

              }

                  .ag-row-odd {
    background-color: #fff !important; /* Light gray */
  }

                    .ag-row-even {
    background-color: #f7f7f7 !important; /* Light gray */
  }






              .ag-root-wrapper{
                border: unset;
                background: transparent
              }

              .ag-body-viewport{
                border: 1px solid #8080801a;
                border-top-left-radius: 5px !important;
                border-top-right-radius: 5px !important;
                background-color: white;
              }

              .ag-theme-quartz .ag-header-cell-filter-button{
              display: none;}

.ag-header-cell-resize:after {
    background-color: #1991eb52;
    content: "";
    display: block;
    height: 30%;
    position: absolute;
    top: calc(50% - 30% * .5);2px;
    z-index: 1;
}

               .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
                  font-size: .9rem;
               }

        .ag-body-vertical-scroll{
            display : none;
          }

    .ag-header-cell-sortable .ag-header-cell-label{
           justify-content: start;
        }
        
        .ag-ltr .ag-cell {
            font-weight: 500 !important;
            letter-spacing: 0.5px;
            color: #2b2b2b !important;
        }


          .odd-row {
          background-color: #f8f8fc;
        }
        
        .span-saceuu7u7{
            font-size: 13px; 
            background-color: #FAAB3C; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkm{
            font-size: 10px; 
            color: #6941C6 ;
            border: solid .1px #6941C6; 
            background-color: #F9F5FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .span-jkmkmkmkmjbui{
            font-size: 10px; 
            color: #175CD3 ;
            border: solid .1px #B2DDFF; 
            background-color: #EFF8FF; 
            padding: .8rem .5rem;
            border-radius: 10rem;
            width: 7rem;
            height:1rem;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
                .ag-header-cell-label{
        display: flex;
        justify-content: center;
        }
         .ag-cell:focus,
  .ag-cell-focus,
  .ag-row-focus {
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }

        
        
  
  `;

  let content = null;

  if (!hasData) {
    content = (
      <div className="flex flex-col justify-center items-center h-[30rem]">
        <img
          src="/Images/doctortable.png"
          alt="No Patients"
          className="w-[400px] mb-4"
        />
        <p className="text-muted text-sm">No Patients Available</p>
      </div>
    );
  } else {
    content = (
      <div
        id="grid-wrapper"
        className="ag-theme-quartz custom-ag-grid"
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#fff",
          minHeight: "32rem",
        }}
      >
        <style>{tableStyle}</style>
        <AgGridReact
          ref={gridRef}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          rowHeight={40}
          headerHeight={30}
          rowBuffer={0}
          rowModelType={"infinite"}
          cacheBlockSize={100}
          cacheOverflowSize={5}
          maxConcurrentDatasourceRequests={1}
          maxBlocksInCache={10}
          animateRows={true}
          onGridReady={onGridReady}
        />
      </div>
    );
  }

  return <div style={{ width: "100%", height: "89%" }}>{content}</div>;
}

export default MedicalBillingTable;
